import { Box, Button, Card, Divider, Typography, useMediaQuery } from '@mui/material'
import React, { useCallback, useEffect, useState } from 'react'
import UserLayout from '../../layouts/UserLayout'
import { useDispatch, useSelector } from 'react-redux'
import { currentUserActions, stockParamsFormActions } from '../../redux/store'
import StockParamsForm from '../../components/StockParamsForm'
import LabelIcon from '@mui/icons-material/Label'
import CloseIcon from '@mui/icons-material/Close'
import { api } from '../../utils/api'
import axios from 'axios'
import { handleError } from '../../utils/error'
import { useNavigate } from 'react-router-dom'
import { getFromStorage } from '../../utils/storage'
import { mainGreen, mainRed } from '../../utils/color'

export default function StockParameter() {
	const { showParamsForm } = useSelector((state) => state.stockParamsForm)
	const { currentUser } = useSelector((state) => state.currentUser)
	const mediaMd = useMediaQuery('(min-width:768px)')
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const token = getFromStorage('current-user')?.accessToken
	const [mainStock, setMainStock] = useState()

	const getMainStock = useCallback(
		async function () {
			try {
				const response = await axios({
					url: api.GET_MAIN_STOCK,
					method: 'GET',
					headers: {
						Authorization: `Bearer ${token}`,
					},
				})
				setMainStock(response.data[0])
			} catch (err) {
				handleError(err)
				dispatch(currentUserActions.isLogout())
				navigate('/login')
			}
		},
		[dispatch, navigate, token],
	)

	useEffect(() => {
		getMainStock()
	}, [getMainStock])

	return (
		<UserLayout>
			<Box
				sx={{
					maxWidth: 992,
					margin: '0 auto',
					padding: '10px 0',
				}}>
				<Card>
					<Box
						sx={{
							textAlign: 'right',
							display: 'flex',
							justifyContent: 'flex-end',
							background: mainGreen,
							padding: '2px 0',
						}}>
						<CloseIcon
							sx={{
								cursor: 'pointer',
								color: '#fff',
							}}
							onClick={() => {
								navigate('/admin/stock')
							}}
						/>
					</Box>
					<Divider />
					<Box
						sx={{
							padding: '10px',
						}}>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								mb: 2,
							}}>
							<h3 style={{ margin: 0 }}>THÔNG SỐ KHO</h3>
							<Button
								variant='contained'
								sx={{
									padding: '0 10px',
									textTransform: 'none',
									background: mainRed,
									'&:hover': { background: mainRed },
								}}
								size='small'
								onClick={() => {
									dispatch(
										stockParamsFormActions.stockParams({
											maxCapacity: mainStock.maxCapacity,
											manufacturePlan: mainStock.manufacturePlan,
										}),
									)
									dispatch(stockParamsFormActions.showStockParamsForm())
								}}>
								Cập nhật
							</Button>
						</Box>
						<Typography sx={{ display: 'flex', alignItems: 'center' }}>
							<LabelIcon sx={{ fontSize: '16px', marginRight: '5px' }} /> Sức chứa tối đa:{' '}
							<span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{mainStock?.maxCapacity} kg</span>
						</Typography>
						<Typography sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
							<LabelIcon sx={{ fontSize: '16px', marginRight: '5px' }} /> Kế hoạch sản xuất:{' '}
							<span style={{ fontWeight: 'bold', marginLeft: '5px' }}>{mainStock?.manufacturePlan} ngày</span>
						</Typography>
					</Box>
				</Card>
			</Box>
			<Box
				position='fixed'
				sx={{
					bottom: 0,
					left: mediaMd ? 300 : 0,
					right: 0,
				}}>
				{showParamsForm && currentUser.permission?.includes('manageStock') && (
					<StockParamsForm getMainStock={getMainStock} />
				)}
			</Box>
		</UserLayout>
	)
}
